import { DatePipe, NgFor, NgIf, TitleCasePipe, CommonModule } from '@angular/common';
import {Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NotesService } from 'app/modules/admin/apps/file-manager/notes/notes.service';
import { DateTime } from 'luxon';
import { Item, ItemPagination } from 'app/modules/admin/apps/file-manager/file-manager.types';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { FileManagerComponent } from '../file-manager.component';
import { NoteService } from 'app/services/note.service';
import { ToastrService } from 'ngx-toastr';
import { Note } from 'app/models/document';
import { EventService } from 'app/services/event.service';
import { NgxLoadingModule } from 'ngx-loading';
import { Util } from 'app/models/util';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from 'app/services/user.service';
import { UserImpl } from 'app/models/user';
import { FullNamePipe, getFullName } from '@fuse/pipes/full-name.pipe';

@Component({
    selector       : 'notes-component',
    templateUrl    : './notes.component.html',
    styleUrls      : ['./notes.component.scss'],
   encapsulation  : ViewEncapsulation.None,
   // changeDetection: ChangeDetectionStrategy.OnPush,
    standalone     : true,
    imports: [
        NgIf,
        NgFor,
        MatIconModule,
        TitleCasePipe,
        DatePipe,
        CommonModule,
        MatTooltipModule,
        MatButtonModule,
        NgxLoadingModule,
        MatRippleModule,
        MatInputModule,
        FullNamePipe,
    ],
})
export class NotesComponent implements OnInit
{
   // notes$: Observable<Note[]>;
    selectedItem : Note = new Note(); 
    canEditNote: boolean = true;
    @Input() docId: Item; 

    public notes : any[] = [];
    public isLoading : boolean = false;

      date = new Date('02/27/2024')
     dateStr ="08:30 AM, 02/27/2024"
     teamDecorator={}
     loginUser = this.util.getUserFromSession();
    // console.log(date| date:'hh:mm a, MM/dd/yyyy')
    /**
     * Constructor
     */

    constructor(
        public _notesService: NotesService,
        public _fileManagerComponent: FileManagerComponent,
        public noteServ : NoteService,
        public toastr : ToastrService,
        public eventSer : EventService,
        public util :Util,
        private sanitizer: DomSanitizer,
        public userServise : UserService,
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

     /**
     * On Changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        
        if (!changes['docId']) {
            return;
        }
        const prev = changes['docId'].previousValue
        const curr = changes['docId'].currentValue
        if (!curr) {
            return;
        }
        if(prev != curr){
            this.docId = curr
            this.getNotes();
        }
      }
      
    /**
     * On init
     */
    ngOnInit(): void {

        // TODO - Get the notes for the selected item
       // this.notes$ = this._notesService.getNotes();
        if (this.docId)
            this.getNotes();

        this.eventSer.getGlobalData.subscribe((data) => {
            if(data == 'note')
            this.getNotes();
        })

        this.getUsers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Returns whether the given dates are different days
     *
     * @param current
     * @param compare
     */
    isSameDay(current: string, compare: string): boolean {
        let dateNw = String(current);
        let com  = String(compare);
        return DateTime.fromISO(dateNw).hasSame(DateTime.fromISO(com), 'day');
    }

    /**
     * Get the relative format of the given date
     *
     * @param date
     */
    getRelativeFormat(date: string): string {
        return DateTime.fromISO(this.getDate(date).toISOString()).toRelativeCalendar();
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    /**
     * Converts a given date string to a Date object.
     * 
     * @param {string} date - The date string to convert.
     * @returns {Date} The converted Date object.
     */
    getDate(date) {
        return new Date(date);
    }

    /**
     * Retrieves the notes for a specific document.
     * Sets the isLoading flag to true before making the API call,
     * and sets it to false after the API call is completed.
     * Populates the notes array with the response data if the API call is successful.
     * Logs any errors to the console if the API call fails.
     */
    getNotes() {
        if (!this.docId) return;
        this.isLoading = true;
        this.noteServ.getNotes(this.docId).then((res)=>{
            this.notes = this.noteServ.getData(res);
            this.renderTeamMembers()
            this.isLoading = false;
        }).catch((error)=>{
            this.isLoading = false;
            console.log(error);
        })
    }

     renderTeamMembers() {
        this.notes.forEach((note:any) => {
			note["innerDiv"] = "";

			if (note.createdBy.profilePic) {
				note["innerDiv"] +=`<img style="min-width: 16px;min-height: 16px;"
                class="shrink-0 w-10 h-10 mr-4 rounded-full overflow-hidden object-cover object-center"
                src="${note.createdBy.profilePic}"
                [alt]="'Note image'">`;
			} else {
				const name = getFullName(note.createdBy).toUpperCase();
				const [first, last] = name.split(" ");
				this.teamDecorator[name] = (first?.substring(0, 1) || '') + (last?.substring(0, 1) || '');
				note["innerDiv"] += ` <div class=" ${this.util.getUserColor(
					name
				)} flex shrink-0 items-center justify-center w-10 h-10 rounded-full font-10"
                style="min-height: 16px; min-width: 16px;">
               ${this.teamDecorator[name]}
            </div>`; 
			}
        });
	}

    public getUsers() {
        let page = new ItemPagination();
        page.page = 0;
        page.size = 250;
        this.isLoading = true;
        this.userServise.getUsers(page).then((res) => {
            let users: UserImpl[] = this.userServise.getData(res);
            let mentionedUsers = users.map((user) => {
                return {
                    id: user.id,
                    value: getFullName(user),
                };
            });
            this.isLoading = false;
            this.util.setMentionedUsers(mentionedUsers);
        }).catch((error) => {
            this.isLoading = false;
          console.log(error);
        })
    }
}
